module.exports = __webpack_public_path__ + "static/media/about2.3ab9ffbb.jpg";